import { render, staticRenderFns } from "./ProjectChooseBeneficiariesReadOnlyView.vue?vue&type=template&id=00fa75e7&"
import script from "./ProjectChooseBeneficiariesReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./ProjectChooseBeneficiariesReadOnlyView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VExpandTransition } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VExpandTransition,VLayout})
